import React, { FunctionComponent } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { DialogTitle, Typography } from '@material-ui/core';
import { eodItemStyles } from '../../eodItemStyles';

type ContinueProps = {
  openErrorDialog: boolean;
  continueDialog: boolean;
  errorMessage: string;
  retryEodProcess: (type: string) => void;
  backToList: () => void;
  openCancelEodDialog: () => void;
};
export const ContinueEodDialog: FunctionComponent<ContinueProps> = ({
  openErrorDialog,
  continueDialog,
  errorMessage,
  retryEodProcess,
  backToList,
  openCancelEodDialog
}) => {
  const classes = eodItemStyles();
  return (
    <div>
      <Dialog aria-labelledby="customized-dialog-title" open={openErrorDialog} fullWidth={true}>
        <DialogTitle id="customized-dialog-title" style={{ backgroundColor: "#3d5a79" }}>
          <Typography className={classes.dialogTitleStyle}>
            Confirmation-Dialog
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText id="alert-dialog-description">
            <Typography className={classes.errorMessageStyle}>
              {continueDialog
                ? "Already started EOD process...Do you want to continue?"
                : errorMessage}
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => { retryEodProcess("retry") }}
          >
            {continueDialog ? "Continue" : "OK"}
          </Button>
          <Button
            onClick={backToList}
          >
            Back
            </Button>
          <Button
            onClick={openCancelEodDialog}
          >
            Cancel
            </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
